import axios from 'axios';

class Search {
  constructor() {
    // 1. describe and create/initiate our object
    this.resultsDiv = document.querySelector('#w-search-overlay__results');
    this.openButton = document.querySelectorAll('.w-search-trigger');
    this.closeButton = document.querySelector(
      '.w-search-overlay .kadence-conversions-close',
    );
    this.searchField = document.querySelector('#search-term');
    this.searchOverlay = document.querySelector('.w-search-overlay');
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.events();
  }

  // 2. events
  events() {
    this.openButton.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.openOverlay();
      });
    });

    this.closeButton.addEventListener('click', () => this.closeOverlay());
    document.addEventListener('keydown', (e) => this.keyPressDispatcher(e));
    this.searchField.addEventListener('keyup', () => this.typingLogic());
  }

  // 3. methods (function, action...)
  typingLogic() {
    if (this.searchField.value != this.previousValue) {
      clearTimeout(this.typingTimer);

      if (this.searchField.value) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>';
          this.isSpinnerVisible = true;
        }
        // this.typingTimer = setTimeout(function () {
        //   console.log('This is a timeout test.');
        // }, 2000);
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        this.resultsDiv.innerHTML = '';
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = this.searchField.value;
  }

  async getResults() {
    try {
      const response = await axios.get(
        wData.root_url + '/wp-json/w/v1/search?term=' + this.searchField.value,
      );
      const results = response.data;
      this.resultsDiv.innerHTML = `
             ${
               results.generalInfo.length
                 ? '<div class="w-flex-row w-flex-cols-2">'
                 : '<p>No general information matches that search</p>'
             }
           ${results.generalInfo
             .map(
               (item) =>
                 `<div class="w-flex-col"><p><a href="${item.permalink}">
               ${item.title}</a></p>
              <p>${item.excerpt || item.yoastDescription || ''}</p>
             </div >`,
             )
             .join('')}
            ${results.generalInfo.length ? '</div>' : ''}
        `;
      this.isSpinnerVisible = false;
    } catch (e) {
      console.log(e);
    }
  }

  openOverlay() {
    this.searchOverlay.classList.add('w-search-overlay--active');
    document.body.classList.add('body-no-scroll');
    // this.searchField.value = '';
    // setTimeout(() => this.searchField.focus(), 301);
    this.isOverlayOpen = true;
    // return false;
  }

  closeOverlay() {
    this.searchOverlay.classList.remove('w-search-overlay--active');
    document.body.classList.remove('body-no-scroll');
    this.searchOverlay.classList.remove('kc-visible');
    this.isOverlayOpen = false;
  }

  keyPressDispatcher(e) {
    // console.log(e.keyCode);
    if (
      e.keyCode == 83 &&
      !this.isOverlayOpen &&
      document.activeElement.tagName != 'INPUT' &&
      document.activeElement.tagName != 'TEXTAREA'
    ) {
      this.openOverlay();
      this.searchOverlay.classList.add('kc-visible');
    }

    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay();
    }
  }
}

export default Search;
